// import { actionTimingPlugin } from './performanceLogging';
export default [
  // actionTimingPlugin({
  //   // include: /^luckysix\//,
  //   // threshold: 10, // ms
  //   // slowTrashhold: 100,
  //   // traceOn: /initProductApps/,
  // }),
];
